import { render, staticRenderFns } from "./ExcellentEmployeesDisplay.vue?vue&type=template&id=a1c5e6e2&scoped=true&"
import script from "./ExcellentEmployeesDisplay.vue?vue&type=script&lang=js&"
export * from "./ExcellentEmployeesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ExcellentEmployeesDisplay.vue?vue&type=style&index=0&id=a1c5e6e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c5e6e2",
  null
  
)

export default component.exports